import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParteaRelatieiComponent } from './partea-relatiei.component';
import { AddParteaRelatieiComponent } from './add-partea-relatiei/add-partea-relatiei.component';
import { EditParteaRelatieiComponent } from './edit-partea-relatiei/edit-partea-relatiei.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        ParteaRelatieiComponent,
        AddParteaRelatieiComponent,
        EditParteaRelatieiComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [ParteaRelatieiComponent],
})
export class ParteaRelatieiModule { }
